import stringify from "safe-stable-stringify";

import type { ReadonlyRecord } from "../types/index.ts";
import { isNullish } from "../types/index.ts";

export function toJsonValue(value: unknown): unknown {
  const text = stringify(value, createErrorReplacer());

  if (isNullish(text)) {
    return null;
  }

  const parsed: unknown = JSON.parse(text);

  return parsed;
}

export function varDump(value: unknown): string | undefined {
  const PADDING = 2;

  return stringify(value, createErrorReplacer(), PADDING);
}

function createErrorReplacer(): (key: string, value: unknown) => unknown {
  const records = new Map<Error, ReadonlyRecord<string, unknown>>();

  return (_key, value) => {
    if (value instanceof Error) {
      const record = records.get(value) ?? errorToRecord(value);

      records.set(value, record);

      return record;
    }

    return value;
  };
}

function errorToRecord(error: Error): ReadonlyRecord<string, unknown> {
  return {
    cause: error.cause,
    errors: error instanceof AggregateError ? error.errors : undefined,
    message: error.message,
    name: error.name,
    ownProperties: { ...error },
    stack: error.stack,
    type: error.constructor.name,
  };
}
